import { SearchOffOutlined } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'

type LocalPqResourceSetsNoResultsProps = {
  onClear: () => void
}

/**
 * Shown in place of the rows when the list has resource sets but the active filters
 * exclude all of them. Distinct from the first-run empty state: it points at
 * the filters (not at creating a resourceSet) and offers a one-click way to clear them.
 */
function LocalPqResourceSetsNoResults({ onClear }: Readonly<LocalPqResourceSetsNoResultsProps>) {
  const { t } = useTranslation()

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        py: 8,
        px: 3,
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          width: 64,
          height: 64,
          borderRadius: '50%',
          color: 'text.secondary',
          backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.06),
        }}
      >
        <SearchOffOutlined fontSize="large" />
      </Box>
      <Stack sx={{ gap: 1, maxWidth: 460 }}>
        <Typography variant="h6">{t('prequalifications.list.no_results.title')}</Typography>
        <Typography color="text.secondary" variant="body2">
          {t('prequalifications.list.no_results.body')}
        </Typography>
      </Stack>
      <CustomButton color="primary" variant="outlined" onClick={onClear}>
        {t('prequalifications.list.no_results.clear')}
      </CustomButton>
    </Stack>
  )
}

export default LocalPqResourceSetsNoResults
